export default __webpack_public_path__ + "static/media/peanuts_1f95c.44364d3a.png";